"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/actions");
const api_1 = require("../../../../utils/api");
const core_1 = require("@material-ui/core");
const themes_1 = require("../../../../utils/themes");
const react_spinners_1 = require("react-spinners");
const modelInfoModal_1 = require("../../../../layouts/modelInfoModal");
const icons_1 = require("../../../../utils/icons");
const graph_component_1 = tslib_1.__importDefault(require("../../../../layouts/graph-component"));
const environment_1 = require("src/environments/environment");
const style_1 = tslib_1.__importDefault(require("src/app/auto-ml/utils/style"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
function ModelSaving(props) {
    const dispatch = react_redux_1.useDispatch();
    const mainStep = react_redux_1.useSelector((state) => state.mainStep.no);
    const finalModelData = react_redux_1.useSelector((state) => state.finalData.finalData);
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const [loading, setLoading] = react_1.useState(false);
    const [description, setDescription] = react_1.useState("");
    const [modelName, setModelName] = react_1.useState("");
    const [nameError, setNameError] = react_1.useState("");
    const [modalOpen, setModalOpen] = react_1.useState(false);
    const [savedDetails, setSavedDetails] = react_1.useState("");
    const [isFinalized, setIsFinalized] = react_1.useState(false);
    const [isViewGraph, setIsViewGraph] = react_1.useState(false);
    const [graphPath, setGraphPath] = react_1.useState("");
    const styleLocal = style_1.default();
    const initialState = {
        projectName: "",
        projectNameError: "",
        projectVersion: "",
        projectVersionError: "",
        problemType: "",
        problemTypeError: "",
        csv: "",
        stackedCSV: {},
        csvError: "",
        csvFileName: "",
        baseURL: "",
        baseURLError: "",
        accessToken: "",
        accessTokenError: "",
        batch: "",
        batchError: "",
        device: "",
        deviceError: "",
        startDate: "",
        startDateError: "",
        sensor: "",
        sensorError: "",
        endDate: "",
        endDateError: "",
        sensorData: [],
    };
    react_1.useEffect(() => {
        localStorage.setItem('pageFlag', 5);
        console.log('final model', finalModelData);
        setGraphPath(finalModelData && `${environment_1.environment.MLBE}/${finalModelData.graph_df_path}`);
    }, []);
    const validateModelName = () => {
        if (!modelName.trim()) {
            setNameError("*Model name is required.");
            return false;
        }
        setNameError("");
        return true;
    };
    const saveFinalModel = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!validateModelName())
            return;
        setLoading(true);
        const finalizedData = {
            projectname: projectInfo.projectname,
            problemtype: projectInfo.problemtype,
            version_name: projectInfo.version_name,
            new_modelname: modelName,
            description: description,
            userid: js_cookie_1.default.get('USER_ID'),
        };
        const finalizeModelRes = yield api_1.finalizedModelSaving(finalizedData);
        console.log("finalizeModelRes", finalizeModelRes.data.project_entry.model_info_for_inference);
        if (finalizeModelRes.data.status === "success") {
            console.log(projectInfo.problemtype);
            if (projectInfo.problemtype == 'rca_ms' || projectInfo.problemtype == "regression") {
                setSavedDetails(finalizeModelRes.data.project_entry.model_info_for_inference);
            }
            else {
                setSavedDetails(finalizeModelRes.data.project_entry);
            }
            setModalOpen(true);
            setIsFinalized(true);
        }
        setLoading(false);
    });
    const finishProcess = () => {
        dispatch(actions_1.saveProjectInitiationData(initialState));
        dispatch(actions_1.changeMainStep(1));
        localStorage.setItem('pageFlag', 1);
    };
    const cancelFinalization = () => {
        setModalOpen(false);
        setIsFinalized(false);
    };
    const formatValue = (value) => {
        return typeof value === 'number' ? value.toFixed(3) : value;
    };
    const decreaseStep = () => {
        dispatch(actions_1.changeMainStep(mainStep - 1));
        localStorage.setItem('pageFlag', 4);
    };
    const handleGraph = () => {
        setIsViewGraph(true);
    };
    const closeGraph = () => {
        setIsViewGraph(false);
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: {
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
            } }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, className: styleLocal.modelSavingContainer },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, component: "span" }, "Save the current model within the project, train a new model, and review all the saved models.")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, container: true, spacing: 2, className: styleLocal.modelSavingContainer },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(core_1.Typography, { className: styleLocal.modelNameText }, "Model Name"),
                react_1.default.createElement(core_1.Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "30px"
                    } },
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, placeholder: "Add model name here", value: modelName, onChange: (e) => setModelName(e.target.value), error: !!nameError, helperText: nameError, InputProps: {
                            style: { height: "100%" }
                        }, variant: "outlined" }))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, projectInfo.problemtype !== 'rca_ms' ?
                react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, marginbottom: 4 }, Object.entries(finalModelData).map(([key, value], index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 4, key: index },
                    react_1.default.createElement(core_1.Box, { sx: { p: 1, borderRadius: 1, textAlign: 'center' } },
                        react_1.default.createElement(core_1.Typography, { className: styleLocal.textCenterAlign, style: { color: "#324054" } }, key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()))),
                    react_1.default.createElement(core_1.Box, { sx: { bgcolor: '#EAEEF8', p: 1, borderRadius: 1, textAlign: 'center' } },
                        react_1.default.createElement(core_1.Typography, { style: { alignItems: "center", fontSize: 14, color: "#868DAA" } }, formatValue(value)))))))
                :
                    react_1.default.createElement(core_1.Grid, { container: true, marginbottom: 4 },
                        react_1.default.createElement(core_1.Table, { className: styleLocal.tableSaveModel },
                            react_1.default.createElement(core_1.TableHead, { style: { width: '100%', backgroundColor: '#FFFFFF' } },
                                react_1.default.createElement(core_1.TableRow, null,
                                    react_1.default.createElement(core_1.TableCell, null, "Method"),
                                    react_1.default.createElement(core_1.TableCell, { className: styleLocal.tableRowGraph }, "Graph"))),
                            react_1.default.createElement(core_1.TableBody, null,
                                react_1.default.createElement(core_1.TableRow, { className: styleLocal.tableRowBackground },
                                    react_1.default.createElement(core_1.TableCell, null, finalModelData && finalModelData.method ? finalModelData.method.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) : "N/A"),
                                    react_1.default.createElement(core_1.TableCell, { className: styleLocal.tableRowGraph },
                                        react_1.default.createElement(core_1.IconButton, { onClick: handleGraph, size: "small", sx: {
                                                boxShadow: 'none',
                                                border: 'none',
                                                background: 'transparent'
                                            } },
                                            react_1.default.createElement(icons_1.ViewIcon, null)))))))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textCenterAlign, style: { marginBottom: "1px", color: "#324054" } }, "Description"),
                react_1.default.createElement(core_1.TextField, { fullWidth: true, multiline: true, minRows: 4, placeholder: "Add description here", value: description, onChange: (e) => setDescription(e.target.value), variant: "outlined" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 1, lg: 1 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 10, lg: 10, className: styleLocal.modelSavingContainer, style: { display: 'flex', justifyContent: 'flex-end' } },
            react_1.default.createElement("div", { className: styleLocal.saveModelButton },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: themes_1.cancelBotton, onClick: () => isFinalized ? cancelFinalization() : decreaseStep() }, isFinalized ? "Cancel" : "Previous"),
                react_1.default.createElement(core_1.Button, { style: themes_1.nextBotton, onClick: () => isFinalized ? finishProcess() : saveFinalModel() }, isFinalized ? 'Finish' : 'Save Endpoint'))),
        react_1.default.createElement(modelInfoModal_1.ModelInfoModal, { open: modalOpen, onClose: () => setModalOpen(false), type: "afterSaved", projectInfo: projectInfo, savedDetails: savedDetails, description: description }),
        react_1.default.createElement(core_1.Dialog, { open: isViewGraph, maxWidth: "md", fullWidth: true, PaperProps: {
                style: { overflow: "hidden" },
            } },
            react_1.default.createElement(core_1.Grid, { container: true },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: styleLocal.graphPopHeader },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", gutterBottom: true }, "View Graph"),
                    react_1.default.createElement(core_1.IconButton, { size: "small", onClick: closeGraph },
                        react_1.default.createElement(icons_1.CloseIconColor, null))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, style: { overflowX: "auto" } },
                    react_1.default.createElement(graph_component_1.default, { csvPath: graphPath }))))));
}
exports.ModelSaving = ModelSaving;
//# sourceMappingURL=model-saving.js.map